import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import UIStrings from '@/Utils/UIStrings';
import ValidationErrors from '@/Utils/ValidationErrors';

const maxSymbols = (maximum: number | bigint) => UIStrings.MaxSymbolsValidationError(maximum);

const billingInfoSchema = z.object({
    billingTo: z
        .string()
        .min(1, ValidationErrors.Required)
        .max(50, { error: ({ maximum }) => maxSymbols(maximum) }),
    city: z
        .string()
        .min(1, ValidationErrors.Required)
        .max(50, { error: ({ maximum }) => maxSymbols(maximum) }),
    country: z
        .string()
        .min(1, ValidationErrors.Required)
        .max(2, { error: ({ maximum }) => maxSymbols(maximum) }),
    addressLine1: z
        .string()
        .min(1, ValidationErrors.Required)
        .max(50, { error: ({ maximum }) => maxSymbols(maximum) }),
    addressLine2: z
        .string()
        .max(50, { error: ({ maximum }) => maxSymbols(maximum) })
        .optional(),
    postalCode: z
        .string()
        .min(1, ValidationErrors.Required)
        .max(10, { error: ({ maximum }) => maxSymbols(maximum) }),
    state: z
        .string()
        .min(1, ValidationErrors.Required)
        .max(50, { error: ({ maximum }) => maxSymbols(maximum) }),
});

export type BillingInfoFormValues = z.infer<typeof billingInfoSchema>;

export const useBillingInfoForm = ({ defaultValues }: { defaultValues: BillingInfoFormValues }) => {
    return useForm<BillingInfoFormValues>({
        resolver: zodResolver(billingInfoSchema),
        mode: 'onSubmit',
        defaultValues,
    });
};
